export default __webpack_public_path__ + "static/media/coffe5.db0c6780.png";